import styled from "styled-components";
interface FilterCursesContentPopUpProps {
  exibition: boolean;
}
export const FilterCursesContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
});

export const FilterCursesContentPopUp = styled("div")<FilterCursesContentPopUpProps>(
  ({ exibition }) => ({
    display: exibition ? "flex" : "none",
    flexDirection: "column",
    position: "absolute",
    zIndex: 10,
    marginTop: "60px",
    padding: "12px",
    overflowY: "scroll",
    maxWidth: "400px",
    maxHeight: "400px",
    borderRadius: "16px",
    background: "#fff",
    fontSize: "12px",
    boxShadow:
      "0rem 0.625rem 0.9375rem -0.1875rem rgba(0, 0, 0, 0.1), 0rem 0.25rem 0.375rem -0.125rem rgba(0, 0, 0, 0.05)",
    "&::-webkit-scrollbar": {
      width: "8px", // Largura da scrollbar
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#007BFF", // Cor da barra de rolagem
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#0056b3", // Cor ao passar o mouse
    },
  })
);

export const FilterCursesLabel = styled("label")({
  fontSize: "12px",
  fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
  "&:hover": {
    color: "#344767",
    background: "#f0f2f5",
  },
});
